
import React, { useEffect, useState } from 'react'
import { Button, Table, Form, Input, Space, Popconfirm, Modal, Select, Tooltip } from 'antd'
//导入图标
import { PlusOutlined } from '@ant-design/icons'

//查询
import { searchFun } from '@/utils'

//导入样式
import '@/scss/common.scss'

// //新增
import Add from './add'
import Playvideo from './Play'

//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set, toJS } from 'mobx'


const App = () => {
    //mobx
    const { VideoStore } = useStore()
    const [form] = Form.useForm()
    const [Url, setUrl] = useState('')
    //查询
    const onFinish = async (values) => {
        let data = searchFun(values)
        runInAction(() => {
            set(VideoStore, { filter: data.content })
            set(VideoStore, { op: data.rule })
            set(VideoStore, { page: 1 })
        })
        await VideoStore.getDataList()
    }
    //重置
    const onReset = () => {
        form.resetFields()
    }
    //获得table数据
    useEffect(() => {
        runInAction(() => {
            set(VideoStore, { filter: '' })
            set(VideoStore, { op: '' })
            set(VideoStore, { page: 1 })
            set(VideoStore, { limit: 10 })
        })
        VideoStore.getDataList()
        // eslint-disable-next-line
    }, [])

    //弹出新增角色框
    const getAddRole = (title) => {
        VideoStore.newselect()
        runInAction(() => {
            set(VideoStore, { isAshow: true })
            set(VideoStore, { title: title })
        })
    }
    //弹出框按钮关闭
    const handleAddRole = () => {
        runInAction(() => {
            set(VideoStore, { isAshow: false })
            set(VideoStore, { selectdata: [] })

        })
    }

    const seedata = (item, title) => {
        let items = toJS(item)
        setUrl(item.video_url)
        runInAction(() => {
            set(VideoStore, { seevalue: items })
            set(VideoStore, { title: title })
            set(VideoStore, { isAshow: true })
        })
    }
    //分页控制
    const onPageChange = (page, pageSize) => {
        runInAction(() => {
            set(VideoStore, { page: page })
            set(VideoStore, { limit: pageSize })
        })
        VideoStore.getDataList()
    }
    //删除
    const confirm = async (item) => {
        let id = toJS(item).id
        await VideoStore.getDeleteButtom(id)
    }
    //下拉框
    const { Option } = Select;


    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
        },
        {
            title: '棚室',
            dataIndex: 'aigreenhouse_name',
        },
        {
            title: '视频地址',
            dataIndex: 'video_url',
            ellipsis: "true",
            render: (text, record, index) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            )
        },
        {
            title: '时间',
            dataIndex: 'createtime',
        },
        {
            title: '操作',
            render: (item) => (
                <Space size="middle">
                    <a onClick={() => seedata(item, '播放视频')}>播放视频</a>
                    <Popconfirm
                        title="是否删除"
                        onConfirm={() => { confirm(item) }}
                        okText="确定"
                        cancelText="取消"
                    >
                        <a href="#">删除</a>
                    </Popconfirm>
                </Space>
            ),
        },
    ]
    return (
        <>
            <div className='topTitle'>
                <div className='titleBtn'>视频管理</div>
            </div>
            <div className='searchBox'>
                <Button type="primary" icon={<PlusOutlined />} className='addTitle' onClick={() => getAddRole('添加视频')}>添加视频</Button>
                <div className='TableInput'>
                    <Form layout="inline" onFinish={onFinish} form={form}>
                        <Form.Item label='关键词'>
                            <Input.Group compact>
                                <Form.Item name='select'>
                                    <Select placeholder="请选择" style={{ width: '100px' }}>
                                        <Option value="aigreenhouse_name">棚室</Option>
                                        <Option value="video_url">视频地址</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item name='keyword'>
                                    <Input placeholder="请输入内容" style={{ width: '260px' }} />
                                </Form.Item>
                            </Input.Group>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                查询
                            </Button>
                            <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                                重置
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className='contextNr'>
                <Table rowKey={record => record.id} columns={columns} dataSource={VideoStore.dataList} className='table-box' pagination={{
                    position: ['bottomRight'],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ['10', '20', '30'],
                    pageSize: VideoStore.limit,
                    current: VideoStore.page,
                    total: VideoStore.total,
                    onChange: (page, pageSize) => onPageChange(page, pageSize),
                }} />
                <Modal
                    title={VideoStore.title}
                    width="700px"
                    key={new Date()}
                    open={VideoStore.isAshow}
                    footer={null}
                    onCancel={handleAddRole}
                    destroyOnClose={true}
                    centered
                >
                    {
                        VideoStore.title === '添加视频' && (<Add />)
                    }
                    {
                        VideoStore.title === '播放视频' && (<Playvideo url={Url} />)
                    }

                </Modal>
            </div>
        </>
    )
}

export default observer(App)